import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { meta } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import { useModalAlert } from '../modals/ModalAlert.jsx';

import FormAnswer from '../forms/FormAnswer.jsx';
import FormBeforeAnswer from '../forms/FormBeforeAnswer.jsx';

const PageCompetition = () => {
  const history = useHistory();
  const [started, setStarted] = useState(false);
  const [resComp, reqComp] = useHttpStatus();
  const [resAns, reqAns] = useHttpStatus();
  const { alert } = useModalAlert();

  useEffect(() => {
    reqComp({ url: 'api/quiz/competitions/self' });
  }, []);

  useEffect(() => {
    if (resComp.status === 'success') {
      const comp = resComp.payload;

      if (comp.answers?.[0] || !comp?.allow?.allowed) {
        history.push('/app');
      }
    }
  }, [resComp.status]);

  useEffect(() => {
    if (started) {
      reqAns({
        url: 'api/quiz/answers',
        method: 'post',
      });
    }
  }, [started]);

  useEffect(() => {
    if (resAns.status === 'error') {
      alert((
        <div className="text-danger">{resAns.payload}</div>
      ));
      history.push('/app');
    }
  }, [resAns.status]);

  return (
    <PageHttp res={resComp}>
      {(competition) => {
        meta.set({ title: competition.title });

        if (!started) {
          return (
            <FormBeforeAnswer
              competition={competition}
              onSubmit={() => setStarted(true)}
            />
          );
        }

        return (
          <PageHttp res={resAns}>
            {(doc) => <FormAnswer {...doc} />}
          </PageHttp>
        );
      }}
    </PageHttp>
  );
};

export default PageCompetition;
